
import visitorInfoWidgetTemplate from '../../templates/visitor_info/visitor_info.ejs';

import CompanyLevelBlockValidator from './CompanyLevelBlockValidator';
import addStyleText from './addStyleText';
import parseTemplate from './parseTemplate';
import GlobalVariables from '../GlobalVariables';
import PhoneCountryData from '../validators/PhoneContryData';
import PhoneValidator from '../validators/PhoneValidator';
import googleAnalyticsObjectInit from './googleAnalyticsObjectInit';
import getGaClientId from './getGaClientId';
import GetChatID from './GetChatID';
import isEnterKeyPressed from './isEnterKeyPressed';
import Cookies from './Cookies';
import getCookieValue from './getCookieValue';

const PhoneOTPHandler = (options) => {
    const init = function () {
        const me = this;
        me.options = options;
        me.$ = ApexChat.ApexChatJquery;
        me.context = me.options.context;
        me.waitTime = 59;
        me.elements = {
            sendOTPWrapper: '#phone_confirmation',
            confirmOTPWrapper: '#otp_confirmation',
            otpCodeSendButton: '#livechat_send_otp',
            otpCodeResendWrapper: '.livechat_resend',
            otpCodeResendButton: '#livechat_resend_otp',
            verifyOTPButton: '#livechat_confirm_otp',
            otpInputSelector: '#otp_confirmation input[name=otpcode]',
            phoneSelector: '#phone_confirmation input[name=phone]',
            secondsWrapper: '#livechat_time_sec',
            minutesWrapper: '#livechat_time_minutes',
            timeoutCounter: '#livechat_remaining_time',
            otpDisclaimer: '.livechat_otp_disclaimer',
            remainingTimeHelper: '#livechat_remaining_time_helper',
        };
        me.styles = {
            SUBMIT_ENABLED: 'apexchat_enabled_submit',
            WARNING_ENABLED: 'apexchat_already_exist',
            ERROR_ENABLED: 'apexchat_error'
        };
    };
    const bind = function (phonemsg) {
        const me = this;
        const otpCodeSendButton = me.context.querySelector(me.elements.otpCodeSendButton);
        me.handleSendOrResendOtp(otpCodeSendButton);
        var otpSentOnCookie = ApexChat.localStorageAPI.Get('otp_sent_on');
        if (otpSentOnCookie) {
            me.showVerifyOTPScreen()
        }

        const enableOTPBtn = function () {
            const span = me.context.querySelector(me.elements.verifyOTPButton);
            span.style.pointerEvents = 'auto';
            span.style.opacity = '1';
            span.style.cursor = 'pointer';
        };

        const disableOTPBtn = function () {
            const span = me.context.querySelector(me.elements.verifyOTPButton);
            span.style.pointerEvents = 'none';
            span.style.opacity = '0.5';
            span.style.cursor = 'not-allowed';
        };
        disableOTPBtn();

        const otpInput = me.context.querySelector(me.elements.otpInputSelector);

        otpInput.addEventListener('input', function () {
            // Remove non-digit characters immediately
            this.value = this.value.replace(/\D/g, '');

            const val = this.value.trim();

            if (/^\d{6}$/.test(val)) {
                me.hideOTPError();
                enableOTPBtn();
            } else {
                disableOTPBtn();
            }
        });
        let attemptCount = 0;
        me.context.querySelector(me.elements.verifyOTPButton).addEventListener('click', function () {
            var chatId = GetChatID(me.options);
            const verifyBtn = me.context.querySelector(me.elements.verifyOTPButton);

            // Block if pointerEvents is none (button is "disabled")
            if (verifyBtn && verifyBtn.style.pointerEvents === 'none') {
                return;
            }
            const pin = me.context.querySelector(me.elements.otpInputSelector)?.value;
            var chatId = GetChatID(me.options);
            const data = {
                phone: ApexChat.localStorageAPI.Get('otp_sent_on'),
                chatId: chatId,
                chatLogId: me.options.chatLogId,
                pin: pin
            };
            // ajax call to verify otp pin
            me.$.getJSON(GlobalVariables.LiveChatServiceUrl + '/Handlers/VerifyOTPHandler.ashx', data, (result) => {
                // Check if OTP verification succeeded
                if (result.data) {
                    // Hide OTP overlay
                    me.$('#livechat_phone_otp_overlay', me.context).removeClass('livechat_phone_otp_show');

                    // Remove the overlay elements after animation delay
                    setTimeout(() => {
                        me.$('#livechat_phone_otp_overlay', me.context).remove();
                        me.$('#livechat_phone_otp_overlay_wrapper', me.context).remove();
                    }, 500);
                } else {
                    // OTP verification failed
                    attemptCount++;
                    disableOTPBtn();
                    const updateVerifyOTPButton = me.context.querySelector(me.elements.verifyOTPButton);
                    me.showOTPError()

                    const invalidOTPLimit = 5;
                    if (attemptCount >= invalidOTPLimit) {
                        // If maximum attempts reached, reset OTP process
                        // Set wait time for resend
                        me.waitTime = 596;

                        // Start countdown timer
                        me.startTimer(true);
                        attemptCount = 0;
                        const otpCodeResendButton = me.context.querySelector(me.elements.otpCodeResendButton);
                        otpCodeResendButton.style.display = 'none';
                        const remainingTimeHelper = me.context.querySelector(me.elements.remainingTimeHelper);
                        remainingTimeHelper.textContent = 'Too many incorrect attempts. Please wait:';
                        const resendInfo = me.context.querySelector('#livechat_resend_info');
                        resendInfo.style.display = 'none';
                        disableOTPBtn(); 
                        otpInput.disabled = true;
                    }
                    // Re-enable "Verify OTP" button after failure
                    updateVerifyOTPButton.classList.remove('pointer-event-none');
                }
            });
        })
        const phoneInput = me.context.querySelector(me.elements.phoneSelector);
        phoneInput.value = phonemsg;
        phoneInput?.addEventListener('keyup', function (event) {
            const key = event.key;
            const isEnter = isEnterKeyPressed(event);
            const originalPhone = me.$(this, me.context).val();

            // Sanitize phone number live (optional but useful)
            if (originalPhone) {
                const cleanedPhone = originalPhone.replace(/[^+\d]/g, '');
                me.$(this, me.context).val(cleanedPhone);
                const validator = Object.create(PhoneValidator);
                validator.phoneCountryData =
                    PhoneCountryData[ApexChat.options.countryCode || 'OTHER'];
                validator.phone = cleanedPhone;
                const validate = validator.validate();
                if (!validate) {
                    me.showError('Invalid phone number.');
                    return;
                } else {
                    me.hideError();
                }
            }

            // If Enter key is pressed
            if (isEnter) {
                me.$(me.elements.otpCodeSendButton, me.context).click();
            }
        });

        me.context.querySelector(me.elements.otpInputSelector)?.addEventListener('keyup', function (event) {
            if (isEnterKeyPressed(event)) {
                const verifyBtn = me.context.querySelector(me.elements.verifyOTPButton);

                // Check if the button is visually disabled (via pointer-events or style)
                const isDisabled =
                    verifyBtn?.style.pointerEvents === 'none' ||
                    verifyBtn?.classList.contains('pointer-event-none');

                if (!isDisabled) {
                    event.preventDefault();
                    me.$(me.elements.verifyOTPButton, me.context).click();
                } else {
                    // Prevent Enter key action if disabled
                    event.preventDefault();
                }
            }
        });


    };

    const handleSendOrResendOtp = function (otpCodeSendButton) {
        const me = this;
        otpCodeSendButton.addEventListener('click', function () {
            if (me.timeLeft > 0) return;
            // me.resetTimer();
            me.$(this, me.context).prop('disabled', true);
            // var name = $('input[name=name]').val();
            const form = otpCodeSendButton.closest('.apexchat_otp_main_content');
            const phone = form.querySelector(me.elements.phoneSelector)?.value || ApexChat.localStorageAPI.Get('otp_sent_on');
            me.formSubmit = true;
            if (
                typeof GlobalVariables.CompanyLevelBlockedPages !== 'undefined' &&
                typeof GlobalVariables.CompanyContextRequest !== 'undefined'
            ) {
                me.companyLevelBlockValidator = new CompanyLevelBlockValidator(
                    GlobalVariables.CompanyLevelBlockedPages,
                    GlobalVariables.CompanyContextRequest,
                    GlobalVariables.CompanyLevelSettings
                );
            }
            if (
                me.companyLevelBlockValidator &&
                me.companyLevelBlockValidator.isSMSNumberBlocked(phone)
            ) {
                // check if typed number is blocked.
                return;
            }
            const validator = Object.create(PhoneValidator);
            validator.phoneCountryData =
                PhoneCountryData[ApexChat.options.countryCode || 'OTHER'];
            validator.phone = phone;
            const validate = validator.validate();
            if (!validate) {
                me.showError('Invalid phone number.');
                return;
            }
            otpCodeSendButton.textContent = 'Sending...';
            sendOtpCode();
            function sendOtpCode() {
                const data = {
                    phone: phone,
                };
                // ajax call to send otp pin
                me.$.getJSON(GlobalVariables.LiveChatServiceUrl + '/Handlers/SendOTPHandler.ashx', data, (result) => {
                    if (result.success) {
                        console.log('send otp handler success....');
                        ApexChat.localStorageAPI.Store('otp_sent_on', phone);
                        me.showVerifyOTPScreen();
                        const remainingTimeHelper = me.context.querySelector(me.elements.remainingTimeHelper);
                        remainingTimeHelper.textContent = 'Resend in:';
                    } else {
                        otpCodeSendButton.textContent = ' Get an OTP code';
                        me.showError('The request failed. Ensure the phone number is correct. If too many attempts were made, the number may be temporarily restricted. Please try again shortly.')
                    }

                });
            }
        });
    }

    const disableBtn = function () {
        var me = this;
        const span = me.context.querySelector(me.elements.otpCodeSendButton);
        span.style.pointerEvents = 'none';
        span.style.opacity = '0.5';
        span.style.cursor = 'not-allowed';
    };

    const enableBtn = function () {
        var me = this;
        const span = me.context.querySelector(me.elements.otpCodeSendButton);
        span.style.pointerEvents = 'auto';
        span.style.opacity = '1';
        span.style.cursor = 'pointer';
    };
    const showVerifyOTPScreen = function () {
        var me = this;
        me.startTimer();
        const resendBtn = me.context.querySelector(me.elements.otpCodeResendButton);
        resendBtn.style.display = 'none';
        me.context.querySelector(me.elements.sendOTPWrapper).style.display = 'none';
        me.context.querySelector(me.elements.confirmOTPWrapper).style.display = 'block';
    }

    const startTimer = function (showResendScreen) {
        const me = this;

        // Get DOM elements for displaying time
        const secondsEl = me.context.querySelector(me.elements.secondsWrapper);
        const minutesEl = me.context.querySelector(me.elements.minutesWrapper);
        const counterEl = me.context.querySelector(me.elements.timeoutCounter);

        // Show the timer display
        counterEl.style.display = 'inline';

        // Initialize countdown variables
        me.timeLeft = me.waitTime;
        const totalTime = me.waitTime;

        // Format function to ensure 2-digit output
        const format = (n) => (n < 10 ? '0' + n : '' + n);

        // Clear any existing timer
        if (me._timerInterval) clearInterval(me._timerInterval);

        // Start the countdown timer
        me._timerInterval = setInterval(() => {
            const minutes = Math.floor(me.timeLeft / 60);
            const seconds = me.timeLeft % 60;

            // Update the timer display
            minutesEl.textContent = format(minutes);
            secondsEl.textContent = format(seconds);

            // Log the time left for debugging
            console.log('Time left::', me.timeLeft);

            me.timeLeft--;

            // If time runs out, stop the timer and reset
            if (me.timeLeft < 0) {
                clearInterval(me._timerInterval);
                me.resetTimer();
                if (showResendScreen) {
                    me.context.querySelector(me.elements.sendOTPWrapper).style.display = 'block';
                    me.context.querySelector(me.elements.confirmOTPWrapper).style.display = 'none';
                    const resendInfo = me.context.querySelector('#livechat_resend_info');
                    resendInfo.style.display = 'inline'
                    const otpInput = me.context.querySelector(me.elements.otpInputSelector);
                    otpInput.disabled = false;
                    me.handleResendCLick();
                    // Reset wait time for next OTP resend
                    me.waitTime = 59;
                }
            }
        }, 1000); // Update every second
    };

    const resetTimer = function () {
        const me = this;

        // Get DOM elements needed for resetting timer and UI
        const seconds = me.context.querySelector(me.elements.secondsWrapper);
        const counterEl = me.context.querySelector(me.elements.timeoutCounter);
        const resendBtn = me.context.querySelector(me.elements.otpCodeResendButton);

        // Reset time display
        seconds.textContent = me.waitTime < 10 ? '0' + me.waitTime : me.waitTime;
        counterEl.style.display = "none";

        // Show and re-enable the resend button
        resendBtn.style.display = 'inline-block';
        resendBtn.textContent = 'Resend';
        resendBtn.style.pointerEvents = 'auto';

        // Add click handler only once (if not already added)
        if (!me.codeResent) {
            resendBtn.addEventListener('click', function () {
                if (me.timeLeft >= 0) return;
                me.handleResendCLick();

            });

            // Prevent duplicate event listeners
            me.codeResent = true;
        }
    };
    const handleResendCLick = function () {
        var me = this;
        // Reset OTP-related UI elements
        const otpCodeSendButton = me.context.querySelector(me.elements.otpCodeSendButton);
        const otpCodeResendButton = me.context.querySelector(me.elements.otpCodeResendButton);
        const otpDisclaimer = me.context.querySelector(me.elements.otpDisclaimer);
        const otpInput = me.context.querySelector(me.elements.otpInputSelector);
        otpDisclaimer.style.display = 'none';
        otpCodeSendButton.textContent = 'Resend';
        otpCodeResendButton.style.display = 'none';
        otpInput.value = '';
        me.hideOTPError();
        // Toggle visibility between OTP input and phone input wrappers
        me.context.querySelector(me.elements.sendOTPWrapper).style.display = 'block';
        me.context.querySelector(me.elements.confirmOTPWrapper).style.display = 'none';
    }
    const showError = function (error) {
        const me = this;
        const errorSpan = me.context.querySelector('#phone_confirmation .apexchat_error_message');
        errorSpan.textContent = error;
        errorSpan.style.display = 'inline';
    };
    const showOTPError = function () {
        var me = this;
        const otpInput = me.context.querySelector(me.elements.otpInputSelector);
        const errorSpan = me.context.querySelector('#otp_confirmation .apexchat_error_message');
        errorSpan.style.display = 'inline';
        otpInput.style.color = 'red';
        otpInput.style.border = '1px solid red';
    };
    const hideOTPError = function () {
        var me = this;
        const errorSpan = me.context.querySelector('#otp_confirmation .apexchat_error_message');
        const otpInput = me.context.querySelector(me.elements.otpInputSelector);
        errorSpan.style.display = 'none';
        otpInput.style.color = '';
        otpInput.style.border = '';
    };

    const hideError = function () {
        const me = this;
        const errorSpan = me.context.querySelector('#phone_confirmation .apexchat_error_message');
        errorSpan.style.display = 'none';
    };
    const showWarning = function () {
        const me = this;
        me.$(me.elements.phoneContainerSelector, me.context).addClass(me.styles.WARNING_ENABLED);
        me.$(me.elements.submitBtnSelector, me.context).removeClass(me.styles.SUBMIT_ENABLED);
        me.$(me.elements.phoneWarningSelector, me.context).show();
        me.$('.apexchat_error_message', me.context).hide();
        me.$('.apexchat_warning_message', me.context).show();
    };
    const hideWarning = function () {
        const me = this;
        me.$(me.elements.phoneContainerSelector, me.context).removeClass(me.styles.WARNING_ENABLED);
        me.$('.apexchat_warning_message', me.context).hide();
    };
    return {
        init,
        bind,
        disableBtn,
        enableBtn,
        showError,
        hideError,
        showWarning,
        hideWarning,
        showVerifyOTPScreen,
        startTimer,
        resetTimer,
        handleSendOrResendOtp,
        handleResendCLick,
        showOTPError,
        hideOTPError
    };
};
export default PhoneOTPHandler;
